var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a-button',_vm._g(_vm._b({attrs:{"title":_vm.text}},'a-button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default",function(){return [_c(_setup.GTView,{attrs:{"text":_vm.text,"width":"100%"}})]}),_vm._l((_vm.$slots),function(data,name){return _vm._t(name,null,null,data)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }